import { t } from 'i18next';

export enum RuleCategory {
  ALGORITHM = 'ALGORITHM',
  CRYPTO_USE = 'CRYPTO_USE',
  KEY_LENGTH = 'KEY_LENGTH',
  KEY_MANAGEMENT = 'KEY_MANAGEMENT',
  HOST_SCAN = 'HOST_SCAN',
  CONFLICTING_KEY_ROLES = 'CONFLICTING_KEY_ROLES',

  ILLEGAL_ATTRIBUTE_MODIFICATION_ALLOWED = 'ILLEGAL_ATTRIBUTE_MODIFICATION_ALLOWED',
  ILLEGAL_OPERATION_ALLOWED_FOR_KEY = 'ILLEGAL_OPERATION_ALLOWED_FOR_KEY',
  ILLEGAL_RETURN_VALUE = 'ILLEGAL_RETURN_VALUE',

  INCORRECT_ATTRIBUTE_CALCULATION = 'INCORRECT_ATTRIBUTE_CALCULATION',
  INCORRECT_DEFAULT_ATTRIBUTE_VALUE = 'INCORRECT_DEFAULT_ATTRIBUTE_VALUE',
  INSECURE_ATTRIBUTE_MODIFICATION = 'INSECURE_ATTRIBUTE_MODIFICATION',
  INSECURE_DEFAULT_VALUE = 'INSECURE_DEFAULT_VALUE',

  INSECURE_KEY_DERIVATION = 'INSECURE_KEY_DERIVATION',
  INSECURE_KEY_EXPORT = 'INSECURE_KEY_EXPORT',
  INSECURE_KEY_IMPORT = 'INSECURE_KEY_IMPORT',

  INVALID_ATTRIBUTE_GENERATED = 'INVALID_ATTRIBUTE_GENERATED',
  INVALID_TEMPLATE_ALLOWED = 'INVALID_TEMPLATE_ALLOWED',
  KEY_MATERIAL_EXPOSED = 'KEY_MATERIAL_EXPOSED',
  UNSAFE_CRYPTOGRAPHY_PERMITTED = 'UNSAFE_CRYPTOGRAPHY_PERMITTED',
}

export const getRuleCategoryLabel = (category: RuleCategory): string => {
  switch (category) {
    case RuleCategory.ALGORITHM:
      return t('ruleCategories.algorithm');
    case RuleCategory.CRYPTO_USE:
      return t('ruleCategories.cryptoUse');
    case RuleCategory.KEY_LENGTH:
      return t('ruleCategories.keyLength');
    case RuleCategory.KEY_MANAGEMENT:
      return t('ruleCategories.keyManagement');
    case RuleCategory.HOST_SCAN:
      return t('ruleCategories.hostScan');
    case RuleCategory.CONFLICTING_KEY_ROLES:
      return t('ruleCategories.conflictingKeyRoles');
    case RuleCategory.ILLEGAL_ATTRIBUTE_MODIFICATION_ALLOWED:
      return t('ruleCategories.illegalAttributeModificationAllowed');
    case RuleCategory.ILLEGAL_OPERATION_ALLOWED_FOR_KEY:
      return t('ruleCategories.illegalOperationAllowedForKey');
    case RuleCategory.ILLEGAL_RETURN_VALUE:
      return t('ruleCategories.illegalReturnValue');
    case RuleCategory.INCORRECT_ATTRIBUTE_CALCULATION:
      return t('ruleCategories.incorrectAttributeCalculation');
    case RuleCategory.INCORRECT_DEFAULT_ATTRIBUTE_VALUE:
      return t('ruleCategories.incorrectDefaultAttributeValue');
    case RuleCategory.INSECURE_ATTRIBUTE_MODIFICATION:
      return t('ruleCategories.insecureAttributeModification');
    case RuleCategory.INSECURE_DEFAULT_VALUE:
      return t('ruleCategories.insecureDefaultValue');
    case RuleCategory.INSECURE_KEY_DERIVATION:
      return t('ruleCategories.insecureKeyDerivation');
    case RuleCategory.INSECURE_KEY_EXPORT:
      return t('ruleCategories.insecureKeyExport');
    case RuleCategory.INSECURE_KEY_IMPORT:
      return t('ruleCategories.insecureKeyImport');
    case RuleCategory.INVALID_ATTRIBUTE_GENERATED:
      return t('ruleCategories.invalidAttributeGenerated');
    case RuleCategory.INVALID_TEMPLATE_ALLOWED:
      return t('ruleCategories.invalidTemplateAllowed');
    case RuleCategory.KEY_MATERIAL_EXPOSED:
      return t('ruleCategories.keyMaterialExposed');
    case RuleCategory.UNSAFE_CRYPTOGRAPHY_PERMITTED:
      return t('ruleCategories.unsafeCryptographyPermitted');
    default:
      return category;
  }
};
